import type { File, Folder } from '@efdigital/ll-addon-data';
import {
  getFileIcon,
  getFolderIcon,
} from '@efdigital/ll-admin-v2/lib/file-icon';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { FolderTitle } from './folder-title.gts';

interface FileItemSignature {
  Args: { item: File; onClick: (item: File) => void };
  Element: HTMLDivElement;
}

interface FolderItemSignature {
  Args: { item: Folder; onClick: (item: Folder) => void };
  Element: HTMLDivElement;
}

export class FileItem extends Component<FileItemSignature> {
  get icon() {
    return getFileIcon(this.args.item.contentType);
  }

  <template>
    <div class="card" ...attributes>
      <div class="card-body text-center">
        <div class="fs-1 lh-1">
          <iconify-icon icon={{this.icon}} />
        </div>
        <button
          class="btn btn-sm p-0 stretched-link lh-sm rounded-0 position-initial text-wrap mw-100"
          type="button"
          {{on "click" (fn @onClick @item)}}
        >{{@item.name}}</button>
      </div>
    </div>
  </template>
}

export class FolderItem extends Component<FolderItemSignature> {
  get icon() {
    return getFolderIcon();
  }

  <template>
    <div class="card" ...attributes>
      <div class="card-body text-center">
        <div class="fs-1 lh-1">
          <iconify-icon icon={{this.icon}} />
        </div>
        <button
          class="btn btn-sm p-0 stretched-link lh-sm rounded-0 position-initial text-wrap mw-100"
          type="button"
          {{on "click" (fn @onClick @item)}}
        ><FolderTitle
            @folderId={{@item.id}}
            as |title|
          >{{title}}</FolderTitle></button>
      </div>
    </div>
  </template>
}
